// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-main .empty-router-alive[data-v-1b7f1fda] {\n  min-height: calc(100vh - 50px);\n}\n.fixed-header + .app-main[data-v-1b7f1fda] {\n  padding-top: 50px;\n}\n.hasTagsView .app-main .empty-router-alive[data-v-1b7f1fda] {\n  min-height: calc(100vh - 87px);\n}", ""]);
// Exports
module.exports = exports;
